// extracted by mini-css-extract-plugin
export default {"dialog":"dialog-components_dialog__HpNUm","close":"dialog-components_close__2zu-v","info":"dialog-components_info__WsGcQ"};